import React, { lazy } from 'react';
const ManufacturersDashboard = lazy(() => import('../containers/Manufacturers/ManufacturersDashboard'));
function ManufacturersRouts() {
    return React.createElement(ManufacturersDashboard, null);
}
export default ManufacturersRouts;
